import { createAction } from "redux-actions"

import { NAVIGATE_TO_COURSE } from "../constants/ActionTypes"

export const navigateToCourse = createAction<string>(NAVIGATE_TO_COURSE)
